import type moment from 'moment';
import { formatDate, LOCAL_TIMEZONE } from '../../../../common/services/date-helper/service';
import { useAppContext } from '../../../hooks/useAppContext';

export interface Props {
    date: moment.MomentInput;
    format: string;
    displayTimeZone?: boolean;
}

export default function ({ date, format, displayTimeZone }: Props) {
    const companySettings = useAppContext().user.company.companySettings;
    const formatted = formatDate(date, format, LOCAL_TIMEZONE, displayTimeZone, companySettings);
    return <span>{formatted}</span>;
}
